import { Action as BaseAction } from '@ngrx/store';
import { ErrorAction } from '../main';
import { RunData } from '../../services/run-management/definitions';

export enum ActionTypes {
  FetchRunData = 'RunManagement.FetchRunData',
  FetchRunDataSuccess = 'RunManagement.FetchRunDataSuccess',
  FetchRunDataFailure = 'RunManagement.FetchRunDataFailure',
  UpdateRunStatus = 'RunManagement.UpdateRunStatus',
  UpdateMultipleRunStatus = 'RunManagement.UpdateMultipleRunStatus',
  RunStatusUpdateSuccess = 'RunManagement.UpdateRunStatusSuccess',
  RunStatusUpdateFailure = 'RunManagement.UpdateRunStatusFailure',
  ClearUpdateRunStatus = 'RunManagement.ClearUpdateRunStatus',
  UpdateRunNote = 'RunManagement.UpdateRunNote',
  RunNoteUpdateSuccess = 'RunManagement.UpdateRunNoteSuccess',
  RunNoteUpdateFailure = 'RunManagement.UpdateRunNoteFailure',
  ClearUpdateRunNote = 'RunManagement.ClearUpdateRunNote',
  FetchRunExportData = 'RunManagement.FetchRunExportData',
  FetchRunExportDataSuccess = 'RunManagement.FetchRunExportDataSuccess',
  FetchRunExportDataFailure = 'RunManagement.FetchRunExportDataFailure',
}

// tslint:disable-next-line:max-line-length
export type Action =
  | FetchRunData
  | FetchRunDataSuccess
  | FetchRunDataFailure
  | FetchRunExportData
  | FetchRunExportDataSuccess
  | FetchRunExportDataFailure
  | UpdateRunStatus
  | UpdateMultipleRunStatus
  | RunStatusUpdateSuccess
  | RunStatusUpdateFailure
  | ClearUpdateRunStatus
  | UpdateRunNote
  | RunNoteUpdateSuccess
  | RunNoteUpdateFailure
  | ClearUpdateRunNote;

// =============================================================================
// Fetch Run Data
// =============================================================================
type FetchRunDataPayload = {
  filter?: string;
  limit?: number;
  offset?: number;
  orderBy?: string;
  orderDir?: string;
  include?: string[];
  searchParams?: {};
};

export class FetchRunData implements BaseAction {
  readonly type = ActionTypes.FetchRunData;
  constructor(public payload?: FetchRunDataPayload) {}
}

export class FetchRunDataSuccess implements BaseAction {
  readonly type = ActionTypes.FetchRunDataSuccess;
  constructor(public payload: RunData) {}
}

export class FetchRunDataFailure implements BaseAction {
  readonly type = ActionTypes.FetchRunDataFailure;
  constructor(public error: Error) {}
}

// =============================================================================
// Fetch Run Export Data
// =============================================================================
type FetchRunExportDataPayload = {
  mode?: string;
};

export class FetchRunExportData implements BaseAction {
  readonly type = ActionTypes.FetchRunExportData;
  constructor(public payload?: FetchRunExportDataPayload) {}
}

export class FetchRunExportDataSuccess implements BaseAction {
  readonly type = ActionTypes.FetchRunExportDataSuccess;
  constructor(public payload: any) {}
}

export class FetchRunExportDataFailure implements BaseAction {
  readonly type = ActionTypes.FetchRunExportDataFailure;
  constructor(public error: Error) {}
}

// =============================================================================
// Update Run Status
// =============================================================================

export type UpdateRunStatusPayload = {
  id: number;
  status: string;
  statusTag: string;
};

export class UpdateRunStatus implements BaseAction {
  readonly type = ActionTypes.UpdateRunStatus;
  constructor(public payload: UpdateRunStatusPayload) {}
}

export class RunStatusUpdateSuccess implements BaseAction {
  readonly type = ActionTypes.RunStatusUpdateSuccess;
  constructor(public payload: UpdateRunStatusPayload) {}
}

export class RunStatusUpdateFailure implements BaseAction, ErrorAction {
  readonly type = ActionTypes.RunStatusUpdateFailure;
  constructor(public error: Error) {}
}

export class ClearUpdateRunStatus implements BaseAction {
  readonly type = ActionTypes.ClearUpdateRunStatus;
  constructor() {}
}

// =============================================================================
// Update Multiple Run Status
// =============================================================================

export type UpdateMultipleRunStatusPayload = {
  id: number;
  status: string;
  statusTag: string;
}[];

export class UpdateMultipleRunStatus implements BaseAction {
  readonly type = ActionTypes.UpdateMultipleRunStatus;
  constructor(public payload: UpdateMultipleRunStatusPayload) {}
}

// =============================================================================
// Update Run Note
// =============================================================================

export type UpdateRunNotePayload = {
  id: string;
  notes: string;
};

export class UpdateRunNote implements BaseAction {
  readonly type = ActionTypes.UpdateRunNote;
  constructor(public payload: UpdateRunNotePayload) {}
}

export class RunNoteUpdateSuccess implements BaseAction {
  readonly type = ActionTypes.RunNoteUpdateSuccess;
  constructor(public payload: UpdateRunNotePayload) {}
}

export class RunNoteUpdateFailure implements BaseAction, ErrorAction {
  readonly type = ActionTypes.RunNoteUpdateFailure;
  constructor(public error: Error) {}
}

export class ClearUpdateRunNote implements BaseAction {
  readonly type = ActionTypes.ClearUpdateRunNote;
  constructor() {}
}
